import type { CompanyListItem } from "@/models/company.model";
import { DEFAULT_PAGE_SIZE } from "@/shared/constants/pagination";
import { useCompanyRepository } from "@/shared/contexts/repository-context";
import { useHasGlobalPermission } from "@/shared/hooks/use-has-permission";
import { getGetCompanyListQueryKey } from "@/spz-api/companies/companies";
import { useGetMeSuspense } from "@/spz-api/user/user";
import { GlobalPermission } from "@spz/shared-domain";
import { useQuery } from "@tanstack/react-query";
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useCompaniesColumns } from "../hooks/use-companies-columns";

export const selectCompanyListViewModel = () => {
  const { data: me } = useGetMeSuspense();
  const companyRepository = useCompanyRepository();
  const hasCompaniesManagementPermission = useHasGlobalPermission(
    GlobalPermission.CompaniesManage,
    me,
  );
  const { t } = useTranslation();

  const { data: companies = [], isLoading } = useQuery<CompanyListItem[]>({
    queryKey: getGetCompanyListQueryKey(),
    queryFn: () => companyRepository.getCompanies(),
  });
  const columns = useCompaniesColumns();
  const table = useReactTable({
    data: companies,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    initialState: {
      pagination: {
        pageSize: DEFAULT_PAGE_SIZE,
      },
    },
    enableMultiSort: false,
    enableColumnResizing: false,
  });

  return {
    t,
    table,
    isLoading,
    hasCompaniesManagementPermission,
  };
};
